/** <datalist>s for IANA time zones and ISO currencies, shared by forms (inputs reference them via `list`). */
export function TimezoneCurrencyLists() {
  return (
    <>
      <datalist id="timezone-options">
        {Intl.supportedValuesOf('timeZone').map((zone) => (
          <option key={zone} value={zone} />
        ))}
      </datalist>
      <datalist id="currency-options">
        {Intl.supportedValuesOf('currency').map((code) => (
          <option key={code} value={code} />
        ))}
      </datalist>
    </>
  );
}
